<template>
  <require from="controls/bs-form-input"></require>
  <require from="controls/bs-form-select"></require>

  <div class="form-row">
    <div class="col-md-12 col-lg-6 col-xl-4">
      <bs-form-input type="text" label="Airline" placeholder="Type to search" value.bind="model.text & debounce" maxlength="100"></bs-form-input>
    </div>
    <div if.bind="!mobileAppService.isMobileApp" class="col-md-12 col-lg-6 col-xl-4">
      <bs-form-select label="Rating" placeholder="Airline ratings" value.bind="model.airlineRating" options.bind="enumService.airlineRatings" value-path="value" name-path="name"></bs-form-select>
    </div>
    <div if.bind="!mobileAppService.isMobileApp" class="col-md-12 col-lg-6 col-xl-4">
      <bs-form-select label="Status" placeholder="Airline status" value.bind="model.airlineStatus" options.bind="enumService.airlineStatuses" value-path="value" name-path="name"></bs-form-select>
    </div>
    <div class="col-md-12 col-lg-6 col-xl-4" if.bind="showArchive && !mobileAppService.isMobileApp">
      <bs-form-select label="Archive" value.bind="model.includeArchived" options.bind="archiveOptions" value-path="value" name-path="name"></bs-form-select>
    </div>
  </div>
</template>
